import { z } from "zod";

import { ingredientSchema } from "./catalog";
import { API_VERSION } from "./common";

export const aiImportRequestSchema = z
  .object({ text: z.string().trim().min(1).max(1000) })
  .strict();

export const importedIngredientSchema = z.object({
  index: z.number().int().nonnegative(),
  name: z.string().min(1),
  quantity: z.number().nonnegative(),
  unit: z.string(),
  notes: z.string().optional(),
  grams: z.number().nullable(),
  candidates: z.array(ingredientSchema),
  selectedIngredientId: z.number().int().positive().optional(),
});

export const aiImportResponseSchema = z.object({
  apiVersion: z.literal(API_VERSION),
  data: z.array(importedIngredientSchema).max(15),
});

export const aiImportUsageResponseSchema = z.object({
  apiVersion: z.literal(API_VERSION),
  data: z.object({
    used: z.number().int().nonnegative(),
    limit: z.number().int().positive(),
    remaining: z.number().int().nonnegative(),
    unlimited: z.boolean(),
    emailVerified: z.boolean(),
  }),
});

export type AiImportRequest = z.input<typeof aiImportRequestSchema>;
export type ParsedAiImportRequest = z.output<typeof aiImportRequestSchema>;
export type ImportedIngredientDto = z.infer<typeof importedIngredientSchema>;
export type AiImportResponse = z.infer<typeof aiImportResponseSchema>;
export type AiImportUsageResponse = z.infer<typeof aiImportUsageResponseSchema>;
